import React from 'react';
import {
  MarketingLayout,
  Section,
  Hero,
  PricingTable,
  CallToAction,
} from '@byscott-io/corebyscott';

const tiers = [
  {
    name: 'Starter',
    price: '$0',
    period: '/month',
    description: 'Perfect for testing and small projects',
    features: [
      '1 application',
      '100 customers',
      'Basic entitlements',
      'Email support',
      'Square payment processing',
    ],
    cta: { label: 'Get Started', href: '/register' },
  },
  {
    name: 'Professional',
    price: '$49',
    period: '/month',
    description: 'For growing SaaS businesses',
    features: [
      '5 applications',
      'Unlimited customers',
      'Full entitlement system',
      'Square payment processing',
      'Priority support',
      'Usage tracking & quotas',
      'Webhooks',
    ],
    cta: { label: 'Start Free Trial', href: '/register' },
    highlighted: true,
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: '',
    description: 'For large-scale operations',
    features: [
      'Unlimited applications',
      'Unlimited customers',
      'Custom integrations',
      'Dedicated support',
      'SLA guarantee',
      'Custom contract terms',
      'On-premise option',
    ],
    cta: { label: 'Contact Sales', href: '/contact' },
  },
];

const faqs = [
  {
    question: 'How does the free tier work?',
    answer: 'The Starter plan is free forever for small projects. You can manage one application with up to 100 customers. When you outgrow it, upgrade to Professional.',
  },
  {
    question: 'Can I switch plans anytime?',
    answer: 'Yes! You can upgrade or downgrade your plan at any time. When you upgrade, you get immediate access to new features. When you downgrade, credits are applied to future billing.',
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major credit cards through Square. Enterprise customers can also pay via invoice with NET-30 terms.',
  },
  {
    question: 'Is there a contract or commitment?',
    answer: 'No contracts for Starter and Professional plans - pay month-to-month and cancel anytime. Enterprise plans have custom terms.',
  },
  {
    question: 'Do you offer discounts for annual billing?',
    answer: 'Yes! Annual billing saves you 20% compared to monthly billing. Contact us for enterprise annual pricing.',
  },
  {
    question: 'What happens to my data if I cancel?',
    answer: 'Your data is retained for 30 days after cancellation. You can export your data at any time, and we provide a full data export before account deletion.',
  },
];

export default function PricingPage() {
  return (
    <MarketingLayout>
      <Hero
        headline="Simple, Transparent Pricing"
        subheadline="Start free, scale as you grow. No hidden fees."
        size="small"
      />

      <Section>
        <PricingTable tiers={tiers} />
      </Section>

      <Section background="gray">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Frequently Asked Questions
          </h2>
          <div className="space-y-8">
            {faqs.map((faq, index) => (
              <div key={index}>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {faq.question}
                </h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </Section>

      <CallToAction
        headline="Still have questions?"
        subheadline="Our team is here to help you find the right plan for your needs."
        primaryCta={{ label: 'Contact Sales', href: '/contact' }}
        secondaryCta={{ label: 'Start Free Trial', href: '/register' }}
        background="indigo"
      />
    </MarketingLayout>
  );
}
